import React from 'react'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import "./Helpdesk.css";

const Helpdesk = ({ user, createSnackbar, addressList}) => {

  const handleHelpDesk = () => {
    if (user.homeOfficeLocation === "" && user.empId === "") {
      return createSnackbar.error("Please provide home office location and employee id");
    } else if (user.homeOfficeLocation === "") {
      return createSnackbar.error("Please provide home office location");
    } else if (user.empId === "") {
      return createSnackbar.error("Please provide employee id");
    }

    let officeInfo = addressList.filter(office => {
      return office.name === user.homeOfficeLocation;
    });

    if (officeInfo.length > 0) {
      const to = officeInfo[0].email;
      const subject = `Print Physical ID Card - (${user.empId}) - (${user.homeOfficeLocation})`;
      const body = `Thanks and regards%0D%0A${user.name}`;
      const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`;
      window.open(gmailURL, '_blank');
    }
  }

  return (
    <div className="helpdesk">
      <div className='helpdesk__content'>
        <Typography variant="body1" component="p">
          To apply for a physical identity card, please send a request to the admin team by clicking on the Helpdesk button.
          <b> Do not forget to attach the downloaded pdf*</b>  to the request.
        </Typography>
      </div>
      <div className='helpdesk__submit'>
        <Button
          variant="contained"
          size="medium"
          color="error"
          onClick={handleHelpDesk}
        >
          Helpdesk
        </Button>
      </div>
    </div>
  )
}

export default Helpdesk;
